import React, { useState } from "react";
import "./WorkExperience.css";

const EXPERIENCES = [
  {
    id: "chibuleo",
    company: "Cooperativa Chibuleo",
    role: "Soporte Técnico & Atención al Cliente",
    period: "2022 – 2023",
    type: "Internship",
    stack: ["Hardware", "Redes", "Soporte TI", "Atención al Usuario"],
    description: [
      "Diagnóstico y resolución de incidencias técnicas de hardware y software en equipos de la cooperativa.",
      "Atención y soporte técnico presencial y remoto a usuarios internos.",
      "Mantenimiento preventivo y correctivo de equipos de cómputo.",
      "Apoyo en la gestión de redes locales y conectividad.",
    ],
  },
  {
    id: "mivilsoft",
    company: "Mivilsoft S.A.",
    role: "Desarrollador de Componentes Odoo",
    period: "2023 – 2024",
    type: "Professional",
    stack: ["Odoo", "Python", "XML", "PostgreSQL", "JavaScript"],
    description: [
      "Desarrollo y personalización de módulos y componentes en la plataforma Odoo ERP.",
      "Implementación de vistas, modelos y wizards para flujos de negocio del cliente.",
      "Integración de módulos con APIs externas y servicios de terceros.",
      "Mantenimiento y depuración de componentes existentes en producción.",
    ],
  },
];

const WorkExperience = () => {
  const [activeJob, setActiveJob] = useState(EXPERIENCES[0].id);

  const selected = EXPERIENCES.find((e) => e.id === activeJob);

  return (
    <section className="work-container" id="experience">
      <div className="section-cmd-header">
        <span className="cmd-prompt-w">❯</span>
        <span className="cmd-text-w">
          cat <span className="cmd-flag-w">./experience.log</span>
        </span>
      </div>
      <h2 className="section-label-w">{'// Experiencia Laboral'}</h2>

      <div className="work-layout">
        {/* Sidebar — job selector */}
        <div className="work-sidebar">
          {EXPERIENCES.map((exp) => (
            <button
              key={exp.id}
              className={`job-tab ${activeJob === exp.id ? "active" : ""}`}
              onClick={() => setActiveJob(exp.id)}
            >
              <span className="tab-prefix">
                {activeJob === exp.id ? "▶" : " "}
              </span>
              <span className="tab-company">{exp.company}</span>
            </button>
          ))}
        </div>

        {/* Main content */}
        <div className="work-detail" key={activeJob}>
          <div className="job-header">
            <div>
              <h3 className="job-role">{selected.role}</h3>
              <span className="job-at">@</span>
              <span className="job-company">{selected.company}</span>
            </div>
            <div className="job-meta">
              <span className="job-type">[{selected.type}]</span>
              <span className="job-period">{selected.period}</span>
            </div>
          </div>

          {/* Stack */}
          <div className="job-stack">
            {selected.stack.map((tech) => (
              <span key={tech} className="stack-tag">
                {tech}
              </span>
            ))}
          </div>

          {/* Description list */}
          <ul className="job-desc">
            {selected.description.map((line, i) => (
              <li key={i} className="job-desc-line">
                <span className="desc-bullet">$</span>
                {line}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WorkExperience;
